import type { $Values } from 'utility-types'

export const EventTypes = {
  ATTENDANCE_SHIFT_SAVED: 'ATTENDANCE_SHIFT_SAVED',
  ATTENDANCE_SHIFT_TOGGLED: 'ATTENDANCE_SHIFT_TOGGLED',
  EMPLOYEES_INVITED: 'EMPLOYEES_INVITED',
  EMPLOYEE_CREATED: 'EMPLOYEE_CREATED',
  JOB_POSTING_CREATED: 'JOB_POSTING_CREATED',
  JOB_POSTING_PUBLISHED: 'JOB_POSTING_PUBLISHED',
  JOB_POSTING_STATUS_CHANGED: 'JOB_POSTING_STATUS_CHANGED',
  LEAVE_CREATED: 'LEAVE_CREATED',
  LEAVE_UPDATED: 'LEAVE_UPDATED',
  ONBOARDING_EVENT_REGISTERED: 'ONBOARDING_EVENT_REGISTERED',
  TIMETRACKING_POLICY_UPDATED: 'TIMETRACKING_POLICY_UPDATED',
  TIMETRACKING_REPORT_DOWNLOADED: 'TIMETRACKING_REPORT_DOWNLOADED',
  INBOX_NOTIFICATIONS_READ: 'INBOX_NOTIFICATIONS_READ',
}

export type EventType = $Values<typeof EventTypes>
